import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { NewsService } from 'src/app/services/news.service';
import { News } from 'src/app/classes/news';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CalendarService } from 'src/app/services/calendar.service';
import { PortalEvent } from 'src/app/classes/calendar';
import { Router } from '@angular/router';
import { DocumentExchange } from 'src/app/classes/document-exchange';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';
import { FileService } from 'src/app/services/file.service';
import { CalendarTypeService } from 'src/app/services/calendar-type.service';
import { Environment } from 'src/app/classes/environment';
import { NewCountersService } from 'src/app/services/new-counters.service';



@Component({
	selector: 'app-start',
	templateUrl: './start-component.html',
	styleUrls: [ '../news/news.component.scss', './start-component.css' ]
})
export class StartComponent implements OnInit, OnDestroy {


	bLoadingNews = true;
	bLoadingDocuments = false;
	bLoadingEvents = true;

	subscriptions = new Subscription();

	news: News[] = [];
	events: PortalEvent[] = [];
	exchange: DocumentExchange[] = [];
	bUnfoldedNews: { [key:string]: boolean } = {};

	bAdmin = this.authenticationService.isAdmin();

	unreadDocumentExchanges: DocumentExchange[] = [];
	bExchange = false;


	constructor(
		private newsService: NewsService,
		private calendarService: CalendarService,
		public domSanitizer: DomSanitizer,
		private authenticationService: AuthenticationService,
		private router: Router,
		private documentExchangeService: DocumentExchangeService,
		private fileService: FileService,
		private calendarTypeService: CalendarTypeService,
		@Inject( "environment" ) private environment: Environment,
		private newCountersService: NewCountersService
	) {}


	ngOnInit() {

		this.bAdmin = this.authenticationService.isAdmin();

		this.bExchange = this.environment.features.austausch; 
		if( this.bExchange ) {

			this.bLoadingDocuments = true;
			this.documentExchangeService.getDocumentExchanges( 0, null, null, false, null, null, "", true ).subscribe( response => {
				this.bLoadingDocuments = false;
				if( response && response.elements ) {
					this.unreadDocumentExchanges = response.elements.slice(0, 5); // Die letzten 5 ungelesenen Nachrichten
				}
			});
			
		}

		this.newsService.getNews().subscribe( news => {

			this.bLoadingNews = false;

			const subscribedRubrics = this.newsService.getStoredSubscribedRubrics();
			this.news = news
				.filter( n => n.bReleased )
				.filter( n => {
					for( const r of n.rubrics ) {
						if( subscribedRubrics.includes( r ) ) return true;
					}
					return false;
				})
				// .filter( n => n.creationTms !== null )
				.sort( (a,b) => {
					if(  ( a.creationTms === null ) && ( b.creationTms === null )  ) return 0;
					if( a.creationTms === null ) return -1;
					if( b.creationTms === null ) return 1;
					return b.creationTms - a.creationTms;
				})
				.slice( 0, 5 );

		});

		const userId = this.authenticationService.getCurrentUser().ebeId;
		this.calendarService.getEventsInGroupsForWhichUserHasSubscribed( userId ).subscribe( events => {
			this.bLoadingEvents = false;
      		const currentDate = Date.now();
			this.events = events
				.filter( e => e.bReleased && e.tmsEnd && e.tmsEnd > currentDate )
				.sort( (a,b) => {
					if( ( a.tmsStart === null ) && ( b.tmsStart === null ) ) return 0;
					if( ( a.tmsStart === null ) ) return -1;
					if( ( b.tmsStart === null ) ) return 1;
					return a.tmsStart - b.tmsStart;
				})
				.slice( 0, 5 );
		});

	}

	ngOnDestroy() {

		this.subscriptions.unsubscribe();

	}


	clickEdit( id: number ) {
		this.router.navigate( [ "News/bearbeiten" ], { queryParams: { id: id } } );
	}

	eventClicked( event: PortalEvent ) {

		/*
		if( this.bAdmin ) {
			this.router.navigate( [ "Veranstaltungen/bearbeiten" ], { queryParams: { id: event.id } } );
		}
		else {
		*/
			this.router.navigate( [ "Veranstaltungen/visualisieren" ], { queryParams: { id: event.id } } );
		// }

	}


	clickEditEvent( id: string ) {
		this.router.navigate( [ "Veranstaltungen/bearbeiten" ], { queryParams: { id: id } } );
	}


	downloadFile( file: { id: string, filename: string }, documentExchange: DocumentExchange ) {

		this.fileService.downloadFileByIdObs( file.id, file.filename ).subscribe( bSuccess => {

			if( !bSuccess ) return;

			this.documentExchangeService.setViewedStatus( documentExchange.id, true ).subscribe( bMarked => {

				if( !bMarked ) return;

				documentExchange.bSeen = true;
				documentExchange.dateFirstRead = Date.now();
				this.unreadDocumentExchanges = this.unreadDocumentExchanges.filter( de => de.id !== documentExchange.id );

			});

		});

		if( !documentExchange.bSeen ) {
			documentExchange.bSeen = true;
			this.newCountersService.decrementNewDocuments();
		}

	}

	onMoreSeeEvents() {

		this.calendarTypeService.setInternalCalendar(false);
		
		this.router.navigate(['/Veranstaltungen'], { state: { bList: true } });

	}

}

